export const compareHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '16px',
  flex: 1,
  minWidth: 0,
};

export const compareHeaderTitleStyles = {
  flex: 'none',
};
